import {Component} from '@angular/core';

@Component({
  selector: 'app-loading',
  standalone: true,
  template: `<div class="spinner"></div>`,
  styleUrl: './loading.component.less'
})
export class LoadingComponent {
}
